(function () {
  var mobileQuery = window.matchMedia
    ? window.matchMedia('(max-width: 1199px)')
    : { matches: true };
  var initialized = new WeakSet();
  var lastOpener = null;
  var lastDrawerOpener = null;
  var drawerWasOpen = false;
  var mobileState = isMobileViewport();
  var drawerCleanupTimer = null;
  var drawerCleanupFollowupTimer = null;
  var suppressDrawerEscapeUntil = 0;

  function isMobileViewport() {
    return window.innerWidth <= 1199;
  }

  function bestMenuUl() {
    var uls = document.querySelectorAll('#menu-mb__ul.mc-mobile-menu-root, ul.mc-mobile-menu-root');
    var fallback = null;
    for (var i = 0; i < uls.length; i++) {
      if (uls[i].querySelector('.mc-mobile-menu-item')) return uls[i];
      fallback = fallback || uls[i];
    }
    return fallback;
  }

  function bestToolbar() {
    var bars = document.querySelectorAll('.mc-mobile-menu-toolbar');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].querySelector('[data-mc-mobile-close]')) return bars[i];
    }
    return bars[0] || null;
  }

  function buildCleanMenuDrawer() {
    var clean = document.querySelector('[data-mc-clean-drawer]');

    if (clean && clean.querySelector('#menu-mb__ul .mc-mobile-menu-item')) return clean;

    var ul = bestMenuUl();
    if (!ul) return clean || null;
    var toolbar = bestToolbar();

    if (!clean) {
      clean = document.createElement('div');
      clean.setAttribute('data-mc-clean-drawer', 'true');
      clean.className = 'mc-clean-menu-drawer';
      clean.setAttribute('role', 'dialog');
      clean.setAttribute('aria-modal', 'true');
      clean.setAttribute('aria-label', 'Menu');
      clean.setAttribute('aria-hidden', 'true');
      document.body.appendChild(clean);
    }

    if (toolbar && toolbar.parentNode !== clean) clean.insertBefore(toolbar, clean.firstChild);
    if (ul.parentNode !== clean) clean.appendChild(ul);
    return clean;
  }

  function getRealDrawer() {
    return document.querySelector('[data-mc-clean-drawer]') || buildCleanMenuDrawer();
  }

  function ensureRealDrawer() {
    return buildCleanMenuDrawer();
  }

  function setOverlay(active) {
    var overlay = document.querySelector('.t4s-close-overlay');
    if (!overlay) return;
    if (active) {
      overlay.classList.remove('t4s-op-0', 't4s-pe-none');
      overlay.style.opacity = '1';
      overlay.style.pointerEvents = 'auto';
    } else {
      overlay.style.opacity = '';
      overlay.style.pointerEvents = '';
      overlay.classList.add('t4s-op-0');
    }
  }

  function openDrawer() {
    updateMenuViewportHeight();
    var drawer = ensureRealDrawer();
    if (!drawer || !isMobileViewport()) return;
    cancelDrawerLockCleanup();

    drawer.classList.add('mc-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mc-menu-open');
    document.body.classList.add('t4s-lock-scroll', 'is--opend-drawer');
    setOverlay(true);
    syncDrawerState(drawer);
  }

  function closeDrawerState() {
    closeAll(false);
    var drawer = getRealDrawer();
    if (drawer) {
      drawer.classList.remove('mc-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.remove('mc-menu-open');
    setOverlay(false);
    if (!document.querySelector('.t4s-drawer[aria-hidden="false"], .mc-drawer-open')) {
      document.body.classList.remove('t4s-lock-scroll', 'is--opend-drawer');
    }
    if (drawer) syncDrawerState(drawer);
  }

  function drawerIsOpen() {
    var drawer = getRealDrawer();
    return !!(drawer && drawer.classList.contains('mc-drawer-open'));
  }

  function isMenuOpener(target) {
    if (!target || !target.closest) return null;
    var opener = target.closest('[data-menu-drawer], .t4s-push-menu-btn, .mc-menu-opener');
    if (!opener) return null;
    var opts = opener.getAttribute('data-drawer-options') || '';
    if (
      opener.hasAttribute('data-menu-drawer') ||
      opts.indexOf('t4s-menu-drawer') !== -1 ||
      opener.classList.contains('t4s-push-menu-btn') ||
      opener.classList.contains('mc-menu-opener')
    ) {
      return opener;
    }
    return null;
  }

  function neutralizeGeckoOpeners() {
    document
      .querySelectorAll(
        '.t4s-push-menu-btn[data-menu-drawer], .t4s-push-menu-btn[data-drawer-options]',
      )
      .forEach(function (opener) {
        var opts = opener.getAttribute('data-drawer-options') || '';
        if (opener.hasAttribute('data-menu-drawer') || opts.indexOf('t4s-menu-drawer') !== -1) {
          opener.classList.add('mc-menu-opener');
          opener.removeAttribute('data-menu-drawer');
          opener.removeAttribute('data-drawer-options');
        }
      });
  }

  function bindGlobalDrawerControls() {
    if (document.documentElement.hasAttribute('data-mc-drawer-controls')) return;
    document.documentElement.setAttribute('data-mc-drawer-controls', 'true');

    function onOpenerActivate(event) {
      if (!isMobileViewport()) return;
      var opener = isMenuOpener(event.target);
      if (!opener) return;
      lastDrawerOpener = opener;
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer();
    }
    document.addEventListener('click', onOpenerActivate, true);

    function onCloseActivate(event) {
      if (!isMobileViewport() || !drawerIsOpen()) return;
      if (
        event.target.closest('.t4s-close-overlay') ||
        event.target.closest('[data-drawer-close]')
      ) {
        event.preventDefault();
        closeDrawerState();
      }
    }
    document.addEventListener('click', onCloseActivate, true);
  }

  function isVisible(element) {
    if (!element || !element.getClientRects().length) return false;
    if (element.closest('[inert], [aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(element);
    return style.visibility !== 'hidden' && style.display !== 'none';
  }

  function focusableElements(container) {
    if (!container) return [];
    var selector =
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(container.querySelectorAll(selector), isVisible);
  }

  function focusDrawer(drawer) {
    var attempts = 0;

    function attemptFocus() {
      if (!drawer || !isMobileViewport() || drawer.getAttribute('aria-hidden') !== 'false') return;
      if (drawer.contains(document.activeElement) && isVisible(document.activeElement)) return;

      attempts += 1;
      var close = drawer.querySelector('[data-mc-mobile-close]');
      var brand = drawer.querySelector('.mc-mobile-menu-toolbar__brand');
      var target = isVisible(close) ? close : isVisible(brand) ? brand : null;
      if (!target && attempts >= 16) target = focusableElements(drawer)[0];
      if (target) focusMenuElement(target);

      if (!drawer.contains(document.activeElement) && attempts < 16) {
        window.setTimeout(attemptFocus, 60);
      }
    }

    window.requestAnimationFrame(attemptFocus);
  }

  function focusPanelBack(panel, back) {
    var attempts = 0;

    function attemptFocus() {
      if (!panel || !back || panel.getAttribute('aria-hidden') !== 'false') return;
      if (panel.contains(document.activeElement)) return;

      attempts += 1;
      if (isVisible(back)) focusMenuElement(back);
      if (!panel.contains(document.activeElement) && attempts < 10) {
        window.setTimeout(attemptFocus, 60);
      }
    }

    window.requestAnimationFrame(attemptFocus);
  }

  function restoreDrawerFocus() {
    var opener =
      lastDrawerOpener ||
      Array.prototype.find.call(document.querySelectorAll('[data-menu-drawer], .mc-menu-opener'), isVisible);
    lastDrawerOpener = null;
    if (!opener || !opener.isConnected || !isVisible(opener)) return;
    window.requestAnimationFrame(function () {
      focusMenuElement(opener);
    });
  }

  function focusMenuElement(target) {
    target.focus({ preventScroll: true });
    // Older browsers may scroll the hidden overflow despite preventScroll.
    resetMenuScroll();
    window.requestAnimationFrame(resetMenuScroll);
  }

  function resetMenuScroll() {
    document
      .querySelectorAll('#t4s-menu-drawer .t4s-sp-section-mb-nav, [data-mc-clean-drawer], [data-mc-clean-drawer] > #menu-mb__ul')
      .forEach(function (section) {
        section.scrollLeft = 0;
      });
  }

  function closePanel(item, restoreFocus) {
    if (!item) return;
    var opener = item.querySelector(':scope > .mc-mobile-menu-opener');
    var panel = item.querySelector(':scope > .mc-mobile-menu-panel');
    item.classList.remove('is-panel-open');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.style.transform = '';
      panel.style.visibility = '';
      panel.style.opacity = '';
      panel.style.pointerEvents = '';
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
    }
    document.documentElement.classList.remove('mc-mobile-menu-panel-active');
    resetMenuScroll();
    if (restoreFocus && opener) {
      focusMenuElement(opener);
      resetMenuScroll();
    }
  }

  function closeAll(restoreFocus) {
    document.querySelectorAll('.mc-mobile-menu-item.is-panel-open').forEach(function (item) {
      closePanel(item, false);
    });
    document.documentElement.classList.remove('mc-mobile-menu-panel-active');
    if (restoreFocus && lastOpener) focusMenuElement(lastOpener);
  }

  function openPanel(item, opener) {
    if (!isMobileViewport() || !item) return;
    closeAll(false);
    var panel = item.querySelector(':scope > .mc-mobile-menu-panel');
    if (!panel) return;
    lastOpener = opener;
    panel.removeAttribute('inert');
    item.classList.add('is-panel-open');

    panel.style.transform = 'none';
    panel.style.visibility = 'visible';
    panel.style.opacity = '1';
    panel.style.pointerEvents = 'auto';
    opener.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    var panelScroll = panel.querySelector('.mc-mobile-menu-panel__scroll');
    if (panelScroll) panelScroll.scrollTop = 0;
    document.documentElement.classList.add('mc-mobile-menu-panel-active');
    var back = panel.querySelector('.mc-mobile-menu-panel__back');
    resetMenuScroll();
    if (back) focusPanelBack(panel, back);
  }

  function closeDrawer() {
    closeDrawerState();
  }

  function clearDrawerLock(drawer) {
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'true') return;
    if (document.querySelector('.t4s-drawer[aria-hidden="false"]')) return;
    document.body.classList.remove('t4s-lock-scroll', 'is--opend-drawer');
  }

  function cancelDrawerLockCleanup() {
    if (drawerCleanupTimer) window.clearTimeout(drawerCleanupTimer);
    if (drawerCleanupFollowupTimer) window.clearTimeout(drawerCleanupFollowupTimer);
    drawerCleanupTimer = null;
    drawerCleanupFollowupTimer = null;
  }

  function scheduleDrawerLockCleanup(drawer) {
    cancelDrawerLockCleanup();
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'true') return;

    drawerCleanupTimer = window.setTimeout(function () {
      drawerCleanupTimer = null;
      clearDrawerLock(drawer);
    }, 420);

    drawerCleanupFollowupTimer = window.setTimeout(function () {
      drawerCleanupFollowupTimer = null;
      clearDrawerLock(drawer);
    }, 620);
  }

  function syncDrawerState(drawer) {
    var isOpen = Boolean(
      drawer && isMobileViewport() && drawer.classList.contains('mc-drawer-open'),
    );
    document.documentElement.classList.toggle('mc-mobile-menu-drawer-open', isOpen);
    resetMenuScroll();
    if (
      isOpen &&
      (!drawerWasOpen ||
        !drawer.contains(document.activeElement) ||
        !isVisible(document.activeElement))
    )
      focusDrawer(drawer);
    if (!isOpen) {
      closeAll(false);
      scheduleDrawerLockCleanup(drawer);
      if (drawerWasOpen) restoreDrawerFocus();
    } else cancelDrawerLockCleanup();
    drawerWasOpen = isOpen;
  }

  function bind(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    function onActivate(event) {
      var opener = event.target.closest('.mc-mobile-menu-opener');
      if (opener && root.contains(opener)) {
        var item = opener.closest('.mc-mobile-menu-item');
        if (item && item.querySelector(':scope > .mc-mobile-menu-panel')) {
          event.preventDefault();
          openPanel(item, opener);
        }
        return;
      }

      var back = event.target.closest('.mc-mobile-menu-panel__back');
      if (back && root.contains(back)) {
        event.preventDefault();
        closePanel(back.closest('.mc-mobile-menu-item'), true);
        return;
      }

      var close = event.target.closest('[data-mc-mobile-close]');
      if (close && root.contains(close)) {
        event.preventDefault();
        closeDrawer();
      }
    }
    root.addEventListener('click', onActivate);
  }

  function init() {
    updateMenuViewportHeight();
    ensureRealDrawer();
    neutralizeGeckoOpeners();
    bindGlobalDrawerControls();
    document.querySelectorAll('.mc-mobile-menu-panel').forEach(function (panel) {
      if (panel.getAttribute('aria-hidden') === 'false') panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    });
    document.querySelectorAll('[data-mc-mobile-menu]').forEach(bind);
    var drawer = getRealDrawer();
    syncDrawerState(drawer);
    if (drawer && !drawer.hasAttribute('data-mc-mobile-observed') && window.MutationObserver) {
      drawer.setAttribute('data-mc-mobile-observed', 'true');

      new MutationObserver(function () {
        syncDrawerState(getRealDrawer());
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
    if (drawer && !drawer.hasAttribute('data-mc-mobile-transition-observed')) {
      drawer.setAttribute('data-mc-mobile-transition-observed', 'true');
      drawer.addEventListener('transitionend', function (event) {
        if (event.target === drawer && event.propertyName === 'transform') clearDrawerLock(drawer);
      });
    }
  }

  document.addEventListener(
    'keydown',
    function (event) {
      var drawer = getRealDrawer();
      var isOpen = Boolean(drawer && isMobileViewport() && drawerIsOpen());
      var openPanelElement = document.querySelector(
        '.mc-mobile-menu-item.is-panel-open > .mc-mobile-menu-panel',
      );

      if (event.key === 'Escape' || event.keyCode === 27) {
        if (openPanelElement) {
          event.preventDefault();
          event.stopImmediatePropagation();
          suppressDrawerEscapeUntil = Date.now() + 350;
          closeAll(true);
        } else if (isOpen) {
          event.preventDefault();
          closeDrawer();
        }
        return;
      }

      if (event.key !== 'Tab' || !isOpen) return;
      var focusScope = openPanelElement || drawer;
      var focusable = focusableElements(focusScope);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;

      if (!focusScope.contains(active)) {
        event.preventDefault();
        focusMenuElement((event.shiftKey ? last : first));
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        focusMenuElement(last);
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        focusMenuElement(first);
      }
    },
    true,
  );

  document.addEventListener(
    'keyup',
    function (event) {
      if (
        (event.key !== 'Escape' && event.keyCode !== 27) ||
        Date.now() > suppressDrawerEscapeUntil
      )
        return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressDrawerEscapeUntil = 0;
    },
    true,
  );

  function handleBreakpointChange() {
    var isMobile = isMobileViewport();
    if (!isMobile && drawerIsOpen()) {
      closeDrawerState();
      document.body.classList.remove('t4s-lock-scroll', 'is--opend-drawer');
    } else if (!isMobile) closeAll(false);
    syncDrawerState(getRealDrawer());
  }

  function updateMenuViewportHeight() {
    document.documentElement.style.setProperty('--mc-menu-viewport-height', window.innerHeight + 'px');
  }

  function handleViewportResize() {
    updateMenuViewportHeight();
    var nextMobileState = isMobileViewport();
    if (nextMobileState === mobileState) return;
    mobileState = nextMobileState;
    handleBreakpointChange();
  }

  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', handleViewportResize);
  else if (mobileQuery.addListener) mobileQuery.addListener(handleViewportResize);

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', init, { once: true });
  window.addEventListener('resize', handleViewportResize, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', handleViewportResize, { passive: true });
  window.addEventListener('orientationchange', handleViewportResize, { passive: true });
  document.addEventListener(
    'pointerdown',
    function (event) {
      var opener =
        isMenuOpener(event.target);
      if (opener && isMobileViewport()) lastDrawerOpener = opener;
    },
    true,
  );
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', function (event) {
    if (!event.target.closest || !event.target.closest('.t4s-sp-section-mb-nav')) return;
    if (!isMobileViewport() || drawerIsOpen()) return;
    openDrawer();
  });
})();
